import { ButtonGradientPrimary, Card, Colors, Icon } from '@amelio/ui-library';

import { CTAArrowIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

export interface StartReviewCTAProps {
    onStart: () => void;
    className?: string;
    isSelfEvaluation?: boolean;
}

/**
 * StartReviewCTAUI
 *
 * Horizontal CTA layout:
 * Text → Arrow → Button
 *
 * Pure UI component.
 */
export const StartReviewCTA = ({
    onStart,
    className = '',
    isSelfEvaluation,
}: StartReviewCTAProps) => {
    const { t } = useAmelioTranslations();
    const buttonText = t(
        isSelfEvaluation
            ? 'startReview.cta.selfEvaluationButtonText'
            : 'startReview.cta.buttonText',
    );
    const cardClasses = `relative flex md:w-[50%] rounded-3xl bg-base-50 p-10 ${className}`;
    return (
        <Card className={cardClasses}>
            {/* Left content */}
            <div className={'flex items-center gap-3'}>
                <div className={'bg-primary-50 rounded-full px-3 py-[11px]'}>
                    <Icon
                        name={'arrow-export-3'}
                        color={Colors.PRIMARY}
                        ariaLabel={'Start review'}
                        className={'text-success-600'}
                    />
                </div>

                <h3 className={'text-navy text-xl font-semibold'}>
                    {t('startReview.cta.cardText')}
                </h3>
            </div>

            {/* Arrow illustration */}
            <CTAArrowIllustration
                className={
                    'pointer-events-none absolute top-[110px] left-[130px] hidden h-[40%] w-[40%] -translate-y-1/2 rotate-8 md:!block'
                }
            />

            {/* CTA button */}
            <div className={'mt-4 flex justify-end md:!mt-8'}>
                <div className={'bg-base-50 rounded-2xl px-6 py-4'}>
                    <ButtonGradientPrimary
                        size={'sm'}
                        onClick={onStart}
                        aria-label={buttonText}
                        leftIcon={
                            <Icon
                                name={'design-designtools'}
                                color={Colors.WHITE}
                            />
                        }
                        className={'gap-2'}
                    >
                        {buttonText}
                    </ButtonGradientPrimary>
                </div>
            </div>
        </Card>
    );
};
